import styled, { css } from 'styled-components';
import { Button, LinkButton } from 'src/components';
import { colorSchemePreserveAttrs } from 'src/utils/colorScheme';

export const HeaderContainer = styled.header.attrs(colorSchemePreserveAttrs)<{ $src: string }>(
  ({ theme, $src }) => css`
    text-align: center;
    padding-bottom: ${theme.sz.s44};
    margin-bottom: -${theme.sz.s44};
    height: 100%;
    background-color: ${theme.co.secondary10};
    background-image: url('${$src}');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    @media (max-width: ${theme.sz.lg}) {
      padding-bottom: ${theme.sz.s10};
      margin-bottom: ${theme.sz.s0};
    }
  `,
);

export const Actions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.sz.s3} ${theme.sz.s8};
  `,
);

export const LeftActions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s6};
  `,
);

export const MemriseLogo = styled(LinkButton)(
  ({ theme }) => css`
    padding: ${theme.sz.s0};

    svg {
      color: ${theme.co.primary20};
      font-size: ${theme.sz.s12};
    }
  `,
);

export const BackButton = styled(Button)(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.sz.s0};
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};
    border-radius: 50%;
    background-color: ${theme.co.neutral90};

    svg {
      color: ${theme.co.secondary0};
      font-size: ${theme.sz.s5};
    }

    &:hover {
      background-color: ${theme.co.secondary90};
    }
  `,
);

export const CloseButton = styled(Button)(
  ({ theme }) => css`
    display: inline-flex;
    padding: ${theme.sz.s0};

    svg {
      color: ${theme.co.neutral99};
      font-size: ${theme.sz.s12};
    }
  `,
);

export const HeaderContent = styled.div(
  ({ theme }) => css`
    margin: auto;
    padding: ${theme.sz.s0} ${theme.sz.s6};
    max-width: ${theme.sz.xxl};
  `,
);

export const Title = styled.h1(
  ({ theme }) => css`
    color: ${theme.co.primary20};
    margin: ${theme.sz.s0};
    max-width: unset;
    ${theme.typography.heading.desktop.accent.xl};

    @media (max-width: ${theme.sz.lg}) {
      ${theme.typography.heading.mobile.l};
    }

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.m};
    }
  `,
);

export const SubTitle = styled.p(
  ({ theme }) => css`
    color: ${theme.co.neutral99};
    margin: ${theme.sz.s2} ${theme.sz.s0} ${theme.sz.s0};
    max-width: unset;
    ${theme.typography.heading.desktop.s};

    @media (max-width: ${theme.sz.lg}) {
      ${theme.typography.heading.mobile.xs};
    }
  `,
);
